import { buttonIcon } from './icons';
import attributeVisibility from '@components/visibility/attributes.json';
import attributeClassDropDown from '@components/class-dropdown/attributes.json';
import { getBlockLabelByName } from '@helpers/utils';
import LinkControls from '@components/link/attributes.json';
import buttonBlockMeta from './block.json';
import edit from './edit';
import save from './save';
import './style.scss';

const {
  blocks: { registerBlockType },
} = wp;
const { name, ...settings } = buttonBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeVisibility,
  ...attributeClassDropDown,
  ...LinkControls,
};

registerBlockType(name, {
  ...settings,
  icon: buttonIcon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
